import * as React from 'react';
import { loadingRow, tableLoading, tableLoadingSwitch } from "./placeholders"

export const columns = (isLoading: boolean) => [
  { name: 'Issued on', width: '150px', sortable: true, ...tableLoading('createdAt', isLoading, 90) },
  {
    name: 'ID', width: '150px', sortable: true, cell: (row) =>
      isLoading ?
        loadingRow(60) :
        <div className="alert-redirect" data-tag="___react-data-table-allow-propagation___" onClick={() => window.open(`/alerts/edit/${row.caseId}/${row.id}`)}>
          {row.id}
          <i className="fas fa-external-link-alt" />
        </div>
  },
  { name: 'Case ID', width: '160px', sortable: true, ...tableLoading('caseId', isLoading, 60) },
  { name: 'Child', width: '200px', sortable: true, ...tableLoading('child', isLoading, 80) },
  { name: 'Country', width: '140px', ...tableLoading('country', isLoading, 60) },
  { name: 'Status', width: '140px', ...tableLoading('status', isLoading, 50) },
  { name: 'Stop FIA error status email', width: '150px', ...tableLoadingSwitch('sendErrorEmailSwitch', isLoading) },
];